import { api } from '../../lib/api';

export interface UploadKeySummary {
  id: string;
  name: string;
  prefix: string;
  expiresAt: string | null;
  revokedAt: string | null;
  lastUsedAt: string | null;
}

export interface CreatedUploadKey {
  id: string;
  name: string;
  prefix: string;
  expiresAt: string | null;
  key: string;
}

export const fetchUploadKeys = () => api.get<{ keys: UploadKeySummary[] }>('/admin/social/upload-keys');
export const createUploadKey = (name: string, gueltigTage: number | null) =>
  api.post<CreatedUploadKey>('/admin/social/upload-keys', { name, gueltigTage });
export const revokeUploadKey = (id: string) => api.delete(`/admin/social/upload-keys/${encodeURIComponent(id)}`);

/** Die Datei passt zum vorhandenen CLI-Loader; keine Admin-Session wird exportiert. */
export function uploadKeyConfiguration(created: CreatedUploadKey, apiUrl: string): string {
  const base = new URL(apiUrl);
  if (!['https:', 'http:'].includes(base.protocol) || base.username || base.password || base.search || base.hash) {
    throw new Error('Die API-Adresse ist ungültig.');
  }
  base.pathname = base.pathname.replace(/\/api\/v1\/?$/, '').replace(/\/$/, '');
  if (!/^cus_[A-Za-z0-9_-]{43}$/.test(created.key) || !/^[A-Za-z0-9_-]+$/.test(created.id)) {
    throw new Error('Der Server hat keinen gültigen Upload-Schlüssel geliefert.');
  }
  return [
    `# Currivium Social-Upload · ${created.expiresAt === null ? 'unbefristet' : `gültig bis ${created.expiresAt}`}`,
    '# Geheim halten. Bei Verlust im Admin widerrufen.',
    `API_URL=${base.toString().replace(/\/$/, '')}`,
    `SOCIAL_UPLOAD_KEY=${created.key}`,
    `SOCIAL_UPLOAD_KEY_ID=${created.id}`,
    '',
  ].join('\n');
}

export function downloadUploadKey(created: CreatedUploadKey): void {
  const contents = uploadKeyConfiguration(created, import.meta.env.VITE_API_URL);
  const url = URL.createObjectURL(new Blob([contents], { type: 'text/plain;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = 'currivium-social-upload.env';
  document.body.appendChild(link);
  try { link.click(); }
  finally {
    link.remove();
    // Der Browser muss den Download erst übernehmen, bevor die Blob-URL verschwindet.
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
